import styled from "styled-components"
import mixins from "../../../styles/mixins";

const Wrap = styled.article`
    padding: 16px;
    min-height: 511px;

    section {
        padding: 16px !important;
    }

    > .h2,
    .page-title {
        margin-bottom: 4px !important;
    }

    .h2 + .body3,
    .page-title + .body3 {
        ${mixins.clampTextLine(2)};
        & + .row-wrap {
            margin-top: 4px;
        }
    }

    .point-color {
        color: rgba(28, 195, 145, 1);
    }

    > .row-wrap {
        gap: 0 8px;

        & ~ .row-wrap {
            margin-top: 8px;
        }

        .img-wrap {
            display: flex;
            gap: 0 10px;
            padding: 5px 10px;
            min-width: 227px;
            max-width: 227px;
            border-radius: 10px;
            background-color: rgba(0, 0, 0, 1);
            justify-content: center;

            &.more {
                min-width: 345px;
                max-width: 100%;
            }
        }

        > * {
            flex: 1 1;
        }

        section {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 16px;
            min-width: 227px;

            &.direction-row {
                gap: 10px 8px;

                .h4 {
                    max-width: 112px;
                    letter-spacing: -0.05em;
                }
            }

            &.total-score-wrap {
                flex-direction: row;
                max-width: 80px;
                min-width: 80px;
                height: 67px;
                align-items: center;
                justify-content: center;
                ${mixins.h1};
                font-weight: 400;
                .point-color {
                    font-weight: 600;
                }
            }

            &.darkcircle-type {
                .row-wrap {
                    .img-cont {
                        width: 100px;
                        height: 60px;

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .level-gauge-wrap {
                        display: flex;
                        justify-content: space-between;
                        width: 110px;
                        padding: 12px 10px;
                        border: 1px solid rgba(238, 238, 238, 1);
                        border-radius: 10px;
                        flex-grow: 1;

                        .caption {
                            color: rgba(132, 132, 132, 1);
                        }
                        .report-badge {
                            white-space: nowrap;
                        }

                        .level-gauge {
                            width: 26px;
                            flex-grow: 0;
                            flex-shrink: 0;
                        }
                    }
                }
            }

            .row-wrap ~ .row-wrap {
                margin-top: 8px;
            }

            section {
                border: 1px solid #eeeeee;
                flex: 1 1;
            }

            &:first-child:last-child {
                .ribbon-graph + .text-cont {
                    height: auto;
                }
            }
        }

        .img-cont {
            position: relative;
            overflow: hidden;
            width: 88px;
            flex-shrink: 0;

            &.detail {
                display: flex;
                gap: 0 10px;
                position: relative;
                height: 108px;
                padding-left: 40px;
                margin-top: 8px;
                overflow: visible;
                flex-grow: 1;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 40px;
                    height: 100%;
                    background-image: url("${process.env.PUBLIC_URL}/image/img_report_detail_tail.png");
                    background-size: contain;
                    background-repeat: no-repeat;
                }

                .img {
                    flex: 1 1;
                    max-width: 254px;
                    height: 100%;
                    border: 1px solid rgba(28, 195, 145, 1);
                    background-color: rgba(34, 39, 39, 1);
                }

                img {
                    display: block;
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }

                .caption {
                    color: rgba(28, 195, 145, 1);
                }
            }

            .caption {
                color: #fff;
                text-align: center;
                font-size: 7px;
                margin-top: 3px;
            }

            &.grow {
                flex: 1 1;
            }

            img {
                display: block;
                width: 100%;
                height: 125px;
                object-fit: cover;
                border-radius: 5px;

                & ~ img {
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
        }

        .point-graph {
            margin: 25px 19px 15px;
        }

        .flex-content-center {
            display: flex;
            justify-content: space-between;

            > *:not(.h4) {
                align-self: center;
            }

            .h4 {
                align-items: flex-start;
            }
        }

        .score-list {
            display: flex;
            margin-top: 13px;

            li {
                display: flex;
                flex-direction: column;
                margin: 0 20px;
                width: 80px;

                &:not(:first-child, :last-child) {
                    align-items: center;
                }

                & ~ li {
                    border-left: 1px solid rgba(238, 238, 238, 1);
                    margin-left: 0;
                    padding-left: 20px;
                    box-sizing: content-box;
                }

                &:first-child {
                    margin-left: 0;
                }
                &:last-child {
                    margin-right: 0;
                    padding-left: 36px;
                }

                .caption {
                    white-space: nowrap;
                    color: rgba(132, 132, 132, 1);
                }

                .value {
                    ${mixins.h2};
                    margin-top: 3px;

                    > span {
                        ${mixins.body3};
                    }
                }
            }
        }

        
        .align-self-end {
            width: 100%;
        }
    }
`;
export default function MeasurementResult({children, type, description, score}) {
    return (
        <Wrap>
            
            <div className="row-wrap">
                <div>
                    <div className="h2 page-title">
                        <span className="point-color">{type}</span> 측정 결과
                    </div>
                    <p className="body3">{description}</p>
                </div>

                {
                    score !== undefined &&
                    <section className="total-score-wrap">
                        <span className="point-color">{score}</span>점
                    </section>
                }
            </div>
            {children}
        </Wrap>
    )
}